import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Permission, Role } from '../../../models/access.model';
import { BusinessModel } from '../../../models/user.model';

export interface UserBusinessAccess {
  businessId: string;
  businessName?: string;
  roles: Role[];
  permissions: Permission[];
}

@Component({
  selector: 'app-user-businesses',
  standalone: false,
  templateUrl: './user-businesses.component.html',
  styleUrls: ['./user-businesses.component.css']
})
export class UserBusinessesComponent {
  @Input() businesses: BusinessModel[] = [];
  @Input() selectedBusiness: BusinessModel | null = null;

  @Output() selectBusiness = new EventEmitter<BusinessModel>();
  @Output() removeRole = new EventEmitter<{ businessId: string; roleId: string }>();

  onSelectBusiness(business: BusinessModel) {
    this.selectBusiness.emit(business);
  }

  onRemoveRole(businessId: string, roleId: string) {
    this.removeRole.emit({ businessId, roleId });
  }
}
